import React, { useRef } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import { XIcon } from 'lucide-react';
import { WaveDivider } from './WaveDivider';
export function FailedSolutions() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  const solutions = ['Las apps de meditación de 20 minutos son imposibles de usar cuando tienes una fila de clientes o una entrega pendiente.', 'Los consejos de "respira profundo" son peligrosos; si lo haces de forma obvia, todos notan que algo te pasa y empiezan las preguntas incómodas.', 'La terapia tradicional es demasiado cara y no tienes el tiempo para sentarte una hora a hablar cada semana.', 'Ignorar el problema solo hace que la explosión sea más fuerte la próxima vez que alguien te presione.'];
  return <section className="bg-slate-50 relative" data-id="element-22">
      <div ref={ref} className="py-16 md:py-24 px-4" data-id="element-23">
        <div className="max-w-3xl mx-auto" data-id="element-24">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} animate={isInView ? {
          opacity: 1,
          y: 0
        } : {}} transition={{
          duration: 0.6
        }} className="text-2xl md:text-3xl lg:text-4xl font-bold text-[#0f1b2d] text-center mb-12" data-id="element-25">
            Lo que has intentado no funciona...
          </motion.h2>

          <div className="space-y-6" data-id="element-26">
            {solutions.map((solution, index) => <motion.div key={index} initial={{
            opacity: 0,
            x: -30
          }} animate={isInView ? {
            opacity: 1,
            x: 0
          } : {}} transition={{
            duration: 0.5,
            delay: 0.2 + index * 0.15
          }} className="flex items-start gap-4 bg-white p-5 rounded-xl shadow-md border-l-4 border-red-400" data-id="element-27">
                <div className="flex-shrink-0 w-8 h-8 bg-red-100 rounded-full flex items-center justify-center" data-id="element-28">
                  <XIcon className="w-5 h-5 text-red-500" data-id="element-29" />
                </div>
                <p className="text-gray-700 text-base md:text-lg leading-relaxed" data-id="element-30">
                  {solution}
                </p>
              </motion.div>)}
          </div>
        </div>
      </div>

      <WaveDivider fillColor="#3d7a8a" data-id="element-31" />
    </section>;
}